module.exports = __webpack_public_path__ + "img/online.e3df4c1c.svg";